// src/TopQuestionNavigation.jsx
import React, { useMemo } from "react";
import BRANDING from './config/branding';

export default function TopQuestionNavigation({
  appName,
  section,
  category,
  categoryList = [],
  categoryIndex = 0,
  questionIndex = 0,
  totalQuestions = 0,
  onBackToCategories,
  onPrev,
  onNext,
  onNavigateCategory,
  isDarkMode,
}) {
  const title = useMemo(() => {
    const sec = section || "Section";
    const cat = category || "Category";
    return `${appName || BRANDING.appName} • ${sec} • ${cat}`;
  }, [appName, section, category]);

  return (
    <div
      className={`rounded-3xl border ${isDarkMode ? 'border-slate-700 bg-slate-800' : 'border-slate-200 bg-white'} shadow-sm`}
      data-tour="question-nav"
    >
      <div className={`px-5 py-4 flex items-center justify-between gap-3 flex-wrap ${isDarkMode ? 'border-b border-slate-700' : ''}`}>
        <button
          onClick={onBackToCategories}
          className={`text-sm font-semibold ${isDarkMode ? 'text-indigo-200' : 'text-indigo-700'} hover:underline`}
          type="button"
          title="Return to category selection"
        >
          ← Back to Categories
        </button>

        <div className={`text-sm ${isDarkMode ? 'text-slate-300' : 'text-slate-700'}`}>
          <span className="font-semibold">{title}</span>
        </div>
      </div>

      <div className="px-5 pb-4 flex items-center justify-between gap-3 flex-wrap">
        <div className="flex items-center gap-2 flex-wrap">
          <span className={`inline-flex items-center rounded-full ${isDarkMode ? 'bg-slate-700 text-slate-300 border-slate-600' : 'bg-slate-100 text-slate-700 border-slate-200'} px-3 py-1 text-xs font-medium border`}>
            Category {categoryIndex + 1} / {categoryList.length || 1}
          </span>

          <span className={`inline-flex items-center rounded-full ${isDarkMode ? 'bg-slate-700 text-slate-300 border-slate-600' : 'bg-slate-100 text-slate-700 border-slate-200'} px-3 py-1 text-xs font-medium border`}>
            Question {questionIndex + 1} / {totalQuestions || "—"}
          </span>
        </div>

        <div className="flex items-center gap-2 flex-wrap">
          <button
            type="button"
            onClick={onPrev}
            className={`inline-flex items-center justify-center px-4 py-2 rounded-xl border ${isDarkMode ? 'border-slate-600 bg-slate-700 text-slate-200 hover:bg-slate-600' : 'border-slate-200 bg-white text-slate-800 hover:bg-slate-50'} disabled:opacity-50 disabled:cursor-not-allowed transition`}
            title="Go to previous question"
          >
            Prev
          </button>

          <button
            type="button"
            onClick={onNext}
            className="inline-flex items-center justify-center px-4 py-2 rounded-xl bg-indigo-600 text-white hover:bg-indigo-700 disabled:opacity-50 disabled:cursor-not-allowed transition"
            title="Go to next question"
          >
            Next
          </button>

          {categoryList.length > 0 ? (
            <select
              value={categoryIndex}
              onChange={(e) => onNavigateCategory?.(Number(e.target.value))}
              className={`rounded-xl border ${isDarkMode ? 'border-slate-600 bg-slate-700 text-slate-200' : 'border-slate-200 bg-white text-slate-800'} px-3 py-2 text-sm min-w-[260px]`}
              title="Jump to category"
            >
              {categoryList.map((c, idx) => (
                <option key={`${c}-${idx}`} value={idx}>
                  {idx + 1}. {c}
                </option>
              ))}
            </select>
          ) : null}
        </div>
      </div>
    </div>
  );
}
